import { numFormatter } from "../../../helpers/utils";
import styled from "styled-components";
import { TooltipHelper } from "../../tooltipHelper";
import LastUpdatedFooter from "../../widgetLastUpdatedFooter";
import { format } from "date-fns";
import AnimatedNumber from "../../animatedNumber";
import { useWidgetContext } from "../../../helpers/hooks/useWidgetContext";
import WidgetLoading from "../../widgetLoading";

const SmallNumberCountWidget = () => {
  const widget = useWidgetContext();
  const rawValue = widget.widgetData?.value;
  const hasValidValue = rawValue !== undefined && rawValue !== null && rawValue !== "";

  const handleWidgetOnClick = () => {
    if (widget.widgetOnClick) {
      widget.widgetOnClick();
    }
  };

  if (widget.widgetLoading || !hasValidValue) {
    return (
      <Wrapper
        className={`${widget.widgetData?.variant || ""} ${widget.isTimelessWidget ? "outline" : ""}`}
      >
        <WidgetLoading />
      </Wrapper>
    );
  }

  return (
    <Wrapper
      className={`${widget.widgetData.variant || ""} ${widget.isTimelessWidget ? "outline" : ""}`}
      onClick={handleWidgetOnClick}
    >
      <div className="widget-content">
        <div className="data-container">
          {widget.widgetData.pre_text && (
            <span className="currency-label">{widget.widgetData.pre_text}</span>
          )}
          <TooltipHelper
            tooltipText={`${widget.widgetData.pre_text} ${formatNumber(
              parseFloat(widget.widgetData.value)
            )}`}
            placement="bottom"
          >
            <span className="value">
              <AnimatedNumber value={widget.widgetData.value} formatter={numFormatter} />
            </span>
          </TooltipHelper>
          {widget.widgetData.additional_value ? (
            <TooltipHelper
              tooltipText={`${widget.widgetData.additional_pre_text} ${formatNumber(
                parseInt(widget.widgetData.additional_value)
              )}`}
              placement="top"
            >
              <span className="additional-value">
                {`${widget.widgetData.additional_pre_text} ${numFormatter(
                  widget.widgetData.additional_value
                )}`}
              </span>
            </TooltipHelper>
          ) : null}
        </div>
        <div className="widget-title">{widget.widgetData.title}</div>
      </div>
      {widget.isTimelessWidget ? (
        <LastUpdatedFooter
          date={format(widget.lastUpdatedTime, "do MMMM yyyy")}
          time={format(widget.lastUpdatedTime, "hh:mm aaa")}
        />
      ) : null}
    </Wrapper>
  );
};

export default SmallNumberCountWidget;

const Wrapper = styled.div`
  border-radius: 20px;
  background-color: ${({ theme }) => theme.widget.background};
  filter: drop-shadow(5px 5px 10px rgba(0, 0, 0, 0.05));
  width: 100%;
  height: 100%;
  cursor: pointer;
  padding: 25px;
  &.danger {
    background-color: #cb2e2e;
    color: #fff;
    .value,
    .currency-label {
      color: #fff !important;
    }
  }
  &.outlined,
  &.outline {
    border: 10px solid #acd5ca;
    color: #0d7459;
    .value,
    .currency-label {
      color: #0d7459 !important;
    }
  }

  .data-container {
    text-align: center;
  }
  .widget-title {
    font-size: 26px;
    line-height: 2rem;
    text-align: center;
    font-weight: 500;
    opacity: 0.8;
  }
  .widget-content {
    display: flex;
    width: 100%;
    height: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;

    .currency-label {
      font-size: 16px;
      font-weight: 500;
      line-height: 1;
      color: ${({ theme }) => theme.tooltip.text};
    }
    .value {
      display: block;
      text-align: center;
      font-size: 4rem;
      line-height: 1.1;
      font-weight: 800;
      letter-spacing: -2px;
      color: ${({ theme }) => theme.tooltip.text};
    }
    .additional-value {
      font-size: 16px;
      font-weight: 500;
    }
  }

  @media (max-width: 995px) {
    padding: 20px;
    .widget-title {
      font-size: 20px;
    }
    .widget-content {
      .currency-label {
        font-size: 13px;
      }
      .value {
        font-size: 2.5rem;
        letter-spacing: -1px;
      }
    }
  }

  @media (max-width: 767px) {
    padding: 16px;
    border-radius: 16px;
    .widget-title {
      font-size: 16px;
    }
    .widget-content {
      .currency-label {
        font-size: 11px;
      }
      .value {
        font-size: 1.8rem;
        letter-spacing: -1px;
      }
      .additional-value {
        font-size: 13px;
      }
    }
  }
`;
